var map = {
	"./Balanand Vidhyalay/1.webp": 4602,
	"./Balanand Vidhyalay/logo.webp": 988,
	"./Bhagwati Vidhyalaya/1.webp": 2681,
	"./Bhagwati Vidhyalaya/logo.webp": 4477,
	"./Gadhpur Vidhyalay/1.webp": 8924,
	"./Gadhpur Vidhyalay/logo.webp": 1662,
	"./Gyandeep Vidhyalaya/1.webp": 6413,
	"./Gyandeep Vidhyalaya/logo.webp": 5193,
	"./Gyanganga Global School/1.webp": 6186,
	"./Gyanganga Global School/logo.webp": 5308,
	"./Harekrushna Vidhyalaya/1.webp": 8230,
	"./Harekrushna Vidhyalaya/logo.webp": 7840,
	"./Industries Expert/1.webp": 2210,
	"./Industries Expert/10.webp": 4430,
	"./Industries Expert/11.webp": 3529,
	"./Industries Expert/12.webp": 2860,
	"./Industries Expert/13.webp": 3727,
	"./Industries Expert/14.webp": 3698,
	"./Industries Expert/15.webp": 5037,
	"./Industries Expert/16.webp": 2208,
	"./Industries Expert/17.webp": 7971,
	"./Industries Expert/18.webp": 966,
	"./Industries Expert/19.webp": 8241,
	"./Industries Expert/2.webp": 2931,
	"./Industries Expert/20.webp": 9957,
	"./Industries Expert/21.webp": 5786,
	"./Industries Expert/22.webp": 8155,
	"./Industries Expert/23.webp": 9784,
	"./Industries Expert/3.webp": 720,
	"./Industries Expert/4.webp": 8265,
	"./Industries Expert/5.webp": 8542,
	"./Industries Expert/6.webp": 991,
	"./Industries Expert/7.webp": 3900,
	"./Industries Expert/8.webp": 5109,
	"./Industries Expert/9.webp": 4010,
	"./Nilkanth Kanya Vidhyalaya/1.webp": 9215,
	"./Nilkanth Kanya Vidhyalaya/logo.webp": 7003,
	"./Nilmadhav Vidhyalaya/1.webp": 8428,
	"./Nilmadhav Vidhyalaya/logo.webp": 9822,
	"./Surat Diamond Girls Association School/1.webp": 9373,
	"./Surat Diamond Girls Association School/logo.webp": 8377
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3576;